import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CheckoutAnalyticsEventName, CheckoutAnalyticsInfo } from 'src/app/enums/app-settings.enum';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';


@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss']
})
export class OtpVerificationComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  @Input('data') data: any;
  otp: string = '';
  otpVerificationScreen: boolean = false;
  mobileNumber: any = '';
  maskedAccountNo: string = '';
  token: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '●',
    inputStyles: {
      width: '36px',
      height: '36px',
    },
  };
  addon: string = '';
  isArabic: boolean;
  showOTPError = true;
  OTPErrorMSG: any;
  enableResendcode: boolean = false;
  mobileErrorMSG: any;
  ismobileScreen: boolean;
  language: string;
  otpVerified: boolean = false;
  env: any;
  showOTPLoader: boolean = false;
  notificationValue: any = '';
  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private UTS: UtilitiesService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private GAS: GoogleAnalyticsService
  ) {
  }


  ngOnInit() {
    const w = document.documentElement.clientWidth || window.innerWidth;
    if (w < 992) {
      this.ismobileScreen = true;
    } else {
      this.ismobileScreen = false;
    }
    this.GAS.otpVerificationCheckout(CheckoutAnalyticsEventName.OTP_VERIFICATION_SCREEN,CheckoutAnalyticsInfo.OTP_SENT);
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    this.language = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.env = this.UTS.getENV();

    /**
* ETWS-689 ETWS-689 || Authorization OTP for Key Transactions start
*/
    if (this.data && this.data?.onlyOTPScreenEnable) {
      this.mobileNumber = this.data?.mobileNumber;
      this.notificationValue = this.data?.notificationValue;
      this.getOTP();
    }
    /**
    * ETWS-689 ETWS-689 || Authorization OTP for Key Transactions end
    */
  }


  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.GAS.otpVerificationCheckout(CheckoutAnalyticsEventName.OTP_VERIFICATION_SCREEN_CLOSE,CheckoutAnalyticsInfo.CLOSE_OTP_POPUP);
 
    this.modalController
      .dismiss({
        dismissed: true,
      })
      .then(() => {
        this.UTS.clearError();
        this.cdr.detectChanges();
      });
  }

  getOTP() {
    this.mobileErrorMSG = '';
    this.UTS.clearError();
    this.productService.generateOTPLogedInUser(this.mobileNumber,this.notificationValue,this.data?.action).subscribe(
      (resp) => {
        this.maskedAccountNo = this.notificationValue;
        this.token = resp?.token;
        this.otpVerificationScreen = true;
        const number = this.mobileNumber;
        this.maskedAccountNo = this.maskMobileNumber(number);
        setTimeout(() => {
          this.resendCodeTimer();
        }, 500);
      },
      (e) => {

        this.mobileErrorMSG = e?.error?.message;
        if (e?.error?.message == "NO_ACCOUNT_EMAIL_FOR_ELIFE_NUMBER") {
          let errorTitle = 'Invalid number';
          let errorMessage =
            'Sorry, this number isn’t registered with e&. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إي آند. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
        }
      }
    );
  }

  resendOTP() {
    if (this.enableResendcode == false) {
      return false;
    }
    this.mobileErrorMSG = '';
    this.ngOtpInput.setValue(null);
    this.showOTPError = false;
    this.UTS.clearError();

    //&& resp.accountId remove account ID for non logged in customer
    this.productService.generateOTPLogedInUser(this.mobileNumber,this.notificationValue, this.data?.action).subscribe(
      (resp) => {
        this.maskedAccountNo = this.notificationValue;
        this.token = resp?.token;
        this.otpVerificationScreen = true;
        this.GAS.otpVerificationCheckout(CheckoutAnalyticsEventName.OTP_VERIFICATION_SCREEN_RESEND,CheckoutAnalyticsInfo.RESEND_OTP);
             
        setTimeout(() => {
          this.resendCodeTimer();
        }, 500);
      },
      (e) => {
        this.mobileErrorMSG = e?.error?.message;
      }
    );
  }

  changeOTP(otp: string) {
    this.showOTPError = false;
    this.otp = otp;
  }

  validateOtp() {
    this.showOTPError = false;
    this.showOTPLoader = true;
    this.UTS.clearError();
    let req = { "accountNo": this.mobileNumber, "authType": "otp", "authValue": this.otp, "token": this.token };
    this.productService.validateOTP(req).subscribe(
      (resp) => {
        this.showOTPError = false;
        this.showOTPLoader = false;
        if (resp.success) {
          this.otpVerified = true;
          this.GAS.otpVerificationCheckout(CheckoutAnalyticsEventName.OTP_VERIFICATION_SCREEN_VERIFY_SUCCESS,CheckoutAnalyticsInfo.MANUALLY_ENTERED_OTP);
       
        } else {
          this.GAS.otpVerificationCheckout(CheckoutAnalyticsEventName.OTP_VERIFICATION_SCREEN_VERIFY_FAIL,CheckoutAnalyticsInfo.MANUALLY_ENTERED_OTP);
          this.translate.get('OTP_INVALID').subscribe((message) => {
            this.showOTPError = true;
            this.OTPErrorMSG = message;
          });
        }
      },
      (e) => {
        this.showOTPLoader = false;
        this.UTS.error(e.error.message);
        this.GAS.otpVerificationCheckout(CheckoutAnalyticsEventName.OTP_VERIFICATION_SCREEN_VERIFY_FAIL,CheckoutAnalyticsInfo.MANUALLY_ENTERED_OTP);
          
      }
    );
  }

  resendCodeTimer() {
    // Set the date we're counting down to
    const d = new Date();
    //'Nov 18, 2021 11:29:00'
    const timer =
      d.getFullYear() +
      '-' +
      Number(Number(d.getUTCMonth()) +
        1) +
      '-' +
      d.getDate() +
      ' ' +
      d.getHours() +
      ':' +
      (d.getMinutes() + 2) +
      ':' +
      d.getSeconds();
    let countDownDate = new Date(timer.replace(/-/g, "/")).getTime();
    // Update the count down every 1 second

    this.enableResendcode = false;
    let x = setInterval(() => {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days: any = Math.floor(distance / (1000 * 60 * 60 * 24));
      days = days < 10 ? '0' + days : days;
      let hours: any = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      hours = hours < 10 ? '0' + hours : hours;
      let minutes: any = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      minutes = minutes < 10 ? '0' + Number(minutes) : Number(minutes);

      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      seconds = seconds < 10 ? '0' + Number(seconds) : Number(seconds);
      // Output the result in an element with id="demo"
      //days + ':' + hours + ':' +
      const timer = minutes + ':' + seconds + '';
      if (
        document.getElementById('reSendOtpTimer') &&
        document.getElementById('reSendOtpTimerInSeconds')
      ) {
        document.getElementById('reSendOtpTimer').innerHTML =
          minutes + ':' + seconds + '';
        document.getElementById('reSendOtpTimerInSeconds').innerHTML =
          Number(minutes * 60) + Number(seconds) + '';
        if (document.getElementById('reSendOtpTimer2') && seconds >= 0) {
          document.getElementById('reSendOtpTimer2').innerHTML =
            minutes + ':' + seconds + '';
        }
        this.cdr.detectChanges();
      } else {
        clearInterval(x);
      }

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        this.enableResendcode = true;
      }
    }, 1000);
  }
  continue() {
    this.modalController.dismiss({
      validated: true,
    });
  }
  maskMobileNumber(mobileNumber: any) {
    if (mobileNumber) {
      let mobileNumberArr = mobileNumber.split('');
      for (let i = 2; i < mobileNumberArr.length - 3; i++) {
        mobileNumberArr[i] = '*';
      }
      for (let i = 0; i < 2; i++) {
        mobileNumberArr[i] = mobileNumberArr[i];
      }
      var returnedMobileNumber = mobileNumberArr.join("");
      return returnedMobileNumber;
    }
  }
}
